import React from 'react';

const ChevronsRight = ({ width, height, color }) => (
    <svg width={width || '15'} height={height || '15'} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color || '#3C3C3B'} d="M10.5761 8.41662C10.8102 8.18656 10.8102 7.81355 10.5761 7.58349L7.43884 4.5V5.33313L10.1523 8.00005L7.43884 10.6684L7.43884 11.5001L10.5761 8.41662Z" />
        <path fill={color || '#3C3C3B'} d="M7.69843 8.41662C7.9325 8.18656 7.9325 7.81355 7.69843 7.58349L4.56116 4.5L4.56116 5.33313L7.2746 8.00005L4.56116 10.6684L4.56116 11.5001L7.69843 8.41662Z" />
    </svg>
);

export default ChevronsRight;